'use strict';

var cov_m3nc6b33p = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/JsonMetadata/lib/JsonMetadata.js',
      hash = '22e3b10bbae31c34602d64a8f0e5696e636da559',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/JsonMetadata/lib/JsonMetadata.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 15
        },
        end: {
          line: 5,
          column: 33
        }
      },
      '1': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 90
        }
      },
      '2': {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 11,
          column: 2
        }
      },
      '3': {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 15,
          column: 2
        }
      }
    },
    fnMap: {
      '0': {
        name: 'JsonMetadata',
        decl: {
          start: {
            line: 4,
            column: 9
          },
          end: {
            line: 4,
            column: 21
          }
        },
        loc: {
          start: {
            line: 4,
            column: 29
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 4
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 89
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 6,
            column: 82
          }
        }, {
          start: {
            line: 6,
            column: 85
          },
          end: {
            line: 6,
            column: 89
          }
        }],
        line: 6
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    f: {
      '0': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JsonMetadata(props) {
  cov_m3nc6b33p.f[0]++;

  var data = (cov_m3nc6b33p.s[0]++, props.jsonMetadata);
  cov_m3nc6b33p.s[1]++;
  return data ? (cov_m3nc6b33p.b[0][0]++, _react2.default.createElement(
    'script',
    { type: 'application/ld+json' },
    (0, _stringify2.default)(data)
  )) : (cov_m3nc6b33p.b[0][1]++, null);
}

cov_m3nc6b33p.s[2]++;
JsonMetadata.propTypes = {
  jsonMetadata: _propTypes2.default.objectOf(_propTypes2.default.string)
};

cov_m3nc6b33p.s[3]++;
JsonMetadata.defaultProps = {
  jsonMetadata: null
};

exports.default = JsonMetadata;